const isMacOs = () => navigator.platform.includes("Mac");

export { isMacOs };
